var React = require('react');

function Marker1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon For Marker#1"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("rect",{"opacity":"0","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("path",{"d":"M5,10.5 C5,6 8,3 12.5,3 C17,3 20,6.75 20,10.5 C20,12.8325623 17.8236613,16.03566 13.470984,20.1092932 C12.9154018,20.6292577 12.0585054,20.6508331 11.4774555,20.1594925 C7.15915182,16.5078313 5,13.2880005 5,10.5 Z M12.5,12 C13.8807119,12 15,10.8807119 15,9.5 C15,8.11928813 13.8807119,7 12.5,7 C11.1192881,7 10,8.11928813 10,9.5 C10,10.8807119 11.1192881,12 12.5,12 Z","fill":"#000000","fillRule":"nonzero","key":1})])]);
}

Marker1.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Marker1;

Marker1.default = Marker1;
